import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { AnnualReportPatents } from '@/module/AnnualReport/model/AnnualReportTypes';
import { PatentValidationAction } from '@/module/Author/Patent/Validation/PatentValidationAction';
import { PatentCard } from '@/module/Author/Patent/components/Card/PatentCard';

interface AnnualPatentsOverviewProps {
  patents: AnnualReportPatents;
}

export function AnnualPatentsOverview({ patents: { patents } }: AnnualPatentsOverviewProps) {
  return (
    <CollapsableGroup
      title="Brevete care aparțin universității / Produse cu drept de proprietate intelectuală"
      items={patents}
      renderValidation={patent => (
        <PatentValidationAction
          variant="compact"
          patentId={patent.id}
        />
      )}
      renderItem={patent => (
        <PatentCard
          patent={patent}
          onClick={() => window.open(`/author/patent/${patent.id}`)}
        />
      )}
    />
  );
}
